import { Box, Grid2, Skeleton } from "@mui/material";
import { addDays, isSameDay, isSameWeek } from "date-fns";
import React from "react";

import useFullTimeShiftsData from "../../controllers/use-full-time-shifts-data";

const CalendarWeekHeaderSkeleton = (date: any) => {
  const { startingDay } = useFullTimeShiftsData();
  const isCurrentWeek = date && isSameWeek(new Date(date), startingDay);
  return (
    <Grid2
      container
      width={"100%"}
      sx={{
        flexGrow: 1,
      }}
    >
      <Grid2
        container
        width={"100%"}
        sx={{
          position: "sticky",
          top: 0,
          height: "64px",
          minHeight: "64px",
          backgroundColor: "rgba(255,255,255)",
          boxShadow: "0px 2px 4px -2px rgba(0, 0, 0, 0.2)",
          flexWrap: "nowrap",
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flex: 1,
            height: "100%",
            overflowX: "hidden",
          }}
        >
          {Array.from({ length: 7 }).map((_, index) => {
            const day = addDays(startingDay, index);
            return (
              <React.Fragment key={index}>
                <Box
                  sx={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    textAlign: "center",
                    height: "100%",
                    position: "relative",
                    paddingLeft: "0.8rem",
                    borderRight: index !== 6 ? "1px solid #E5E5E5" : "1px solid transparent",
                    borderTop: "1px solid #E5E5E5",
                    borderBottom: "1px solid #E5E5E5",
                    backgroundColor:
                      isCurrentWeek && isSameDay(day, new Date())
                        ? "rgba(47, 77, 139, 0.04)"
                        : "",
                    width: "172px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start",
                    }}
                  >
                    <Skeleton variant="text" width={80} height={26} />
                    <Skeleton variant="text" width={40} height={38} />
                  </Box>
                </Box>
              </React.Fragment>
            );
          })}
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default CalendarWeekHeaderSkeleton;